import { Link } from "react-router-dom";
import { Mail, Shield, MessageSquare } from "lucide-react";
import { LegalPage, Section } from "../components/LegalPage";

export default function Contact() {
  return (
    <LegalPage
      title="Contact"
      updated="26 February 2026"
      intro="The fastest way to reach us is email. We aim to reply within two working days."
    >
      <Section title="General enquiries">
        <p className="flex items-center gap-2">
          <Mail className="w-4 h-4 text-emerald-500" />
          <a className="text-emerald-500 underline" href="mailto:hello@shouldibuyit.co.uk">hello@shouldibuyit.co.uk</a>
        </p>
        <p>For feedback, partnership enquiries or general questions.</p>
      </Section>

      <Section title="Privacy & data requests">
        <p className="flex items-center gap-2">
          <Shield className="w-4 h-4 text-emerald-500" />
          <a className="text-emerald-500 underline" href="mailto:hello@shouldibuyit.co.uk">hello@shouldibuyit.co.uk</a>
        </p>
        <p>
          For rights under the UK GDPR (access, correction, erasure, withdrawal of consent etc.) please write
          to the address above. We will respond within one calendar month. See the{" "}
          <Link to="/privacy" className="text-emerald-500 underline">Privacy Policy</Link> for the full scope of
          your rights.
        </p>
      </Section>

      <Section title="Report a bad recommendation">
        <p className="flex items-center gap-2">
          <MessageSquare className="w-4 h-4 text-emerald-500" />
          <a className="text-emerald-500 underline" href="mailto:hello@shouldibuyit.co.uk">hello@shouldibuyit.co.uk</a>
        </p>
        <p>
          Please include the question you asked and a short description of what was wrong. See also the{" "}
          <Link to="/ai-disclaimer" className="text-emerald-500 underline">AI Disclaimer</Link>.
        </p>
      </Section>
    </LegalPage>
  );
}
